export const saveNavigationPathname = (key: string, pathname: string) => {
  localStorage.setItem(key, pathname)
}

export const getNavigationPathname = (key: string) => {
  return localStorage.getItem(key)
}
